import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, Icon, Upload, message, DatePicker } from "antd";
import InputForm from "./InputForm";
import { CPFValido, CNPJValido } from '../utils/Validator';
import { maskTelefone, maskCNPJ, maskCPF } from '../utils/Masker';
import axios from 'axios';
import "./Form.css";
import { maskDate, maskDecimal } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import MunicipioFrame from './MunicipioFrame';

const { Item: ItemForm } = Form;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Você só pode enviar arquivos JPG / PNG!');
  }
  const isLt2M = file.size / 1024 / 1024 < 0.1;
  if (!isLt2M) {
    message.error('A imagem deve ter menos de 100 KB!');
  }
  return isJpgOrPng && isLt2M;
}


export default class EmpresaForm extends Component {
  state = {
    registro: {
      emp_codigo: '',
      emp_nome: '',
      emp_razao_social: '',
      emp_email: '',
      emp_situacao: '',
      emp_cpf_cnpj: '',
      emp_cep: '',
      emp_endereco: '',
      emp_numero: '',
      emp_complemento: '',
      emp_bairro: '',
      cmun_uf: '',
      emp_pasta_catalogo: '',
      emp_data_contrato: '',
      emp_vlr_mensal: 0,
      emp_obs: '',

      imgNome: '',
      imgSize: '0',
      imgData: '',
      base64: '',
      pathImagem: null,
    },
    carregandoCEP: false,
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        // this.refs.emp_cpf_cnpj.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['emp_data_contrato'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ emp_data_contrato: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onChangeMunicipio = event => {
    const { registro } = this.state;
    registro['emp_municipio'] = event.emp_municipio;
    this.setState(event);
  }


  onBuscarCEPClick = (cep) => {
    // console.log('onBuscarCEPClick: ', cep);
    this.setState({ carregandoCEP: true })
    const { registro } = this.state;

    fetch("https://viacep.com.br/ws/" + cep + "/json/")
      .then(res => res.json())
      .then(
        (result) => {
          // console.log('onBuscarCEPClick-OK: ', result);
          registro.emp_endereco = result.logradouro;
          registro.emp_bairro = result.bairro;
          // registro.cmun_uf = {
          //   key: result.uf,
          //   label: result.uf
          // };
          registro.emp_municipio = {
            key: result.ibge,
            label: result.localidade,
            cmun_uf: String(result.uf),
            cuf_sigla: result.uf,
          };

          this.setState({
            registro,
            carregandoCEP: false,
          })
        },
        (error) => {
          // console.log('onBuscarCEPClick-ERRO: ', error);
          this.setState({
            carregandoCEP: false,
          })
        }
      )
  }

  onGravarParametrosClick = () => {
    Modal.confirm({
      title: 'Confirmação de Cadastros Padrão',
      content: `Deseja gerar os cadastros padrão para esta empresa?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {

        // console.log('onGravarParametrosClick');
        axios.put(`/empresas/cadastrosAuto/${this.state.registro.emp_codigo}`)
          .then(response => {
            this.setState({ carregando: false })
            message.success('Parametros gravados com sucesso.');
          })
          .catch(error => {
            console.error(error.response);
            this.setState({ carregando: false })
            Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  }



  onOK = () => {
    if ((!this.state.registro.emp_cpf_cnpj) || (this.state.registro.emp_cpf_cnpj === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CNPJ' });
      return;
    }
    const PFJ = this.state.registro.emp_cpf_cnpj ? this.state.registro.emp_cpf_cnpj.replace(/[^\d]/g, '') : '';
    if (PFJ.length === 11) {
      if (!CPFValido(PFJ)) {
        Modal.warning({ title: 'Aviso!', content: 'CPF Inválido', });
        return;
      }
    } else if (PFJ.length > 11) {
      if (!CNPJValido(PFJ)) {
        Modal.warning({ title: 'Aviso!', content: 'CNPJ Inválido', });
        return;
      }
    }

    if ((!this.state.registro.emp_nome) || (this.state.registro.emp_nome === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome da Empresa' });
      return;
    }
    if ((!this.state.registro.emp_razao_social) || (this.state.registro.emp_razao_social === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Razão Social da Empresa' });
      return;
    }
    if ((!this.state.registro.emp_email) || (this.state.registro.emp_email === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Email da Empresa' });
      return;
    }
    if ((!this.state.registro.emp_municipio) || (this.state.registro.emp_municipio.key === '0') || (this.state.registro.emp_municipio.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Município' });
      return;
    }
    if ((!this.state.registro.emp_data_contrato) || (!moment(this.state.registro.emp_data_contrato, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }

    if ((this.state.registro.imgNome) && (parseInt(this.state.registro.imgSize) > 0) && (parseInt(this.state.registro.imgSize) > 100000)) {
      Modal.warning({
        title: 'Imagem Inválida',
        content: 'Imagem muito grande.',
        okText: 'OK',
      })
    }


    this.state.registro.emp_municipio = this.state.registro.emp_municipio.key;
    this.state.registro.emp_cpf_cnpj = this.state.registro.emp_cpf_cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');
    this.state.registro.emp_vlr_mensal = parseFloat(this.state.registro.emp_vlr_mensal);
    this.state.registro.emp_data_contrato = moment(this.state.registro.emp_data_contrato, 'DD/MM/YYYY').format('YYYY-MM-DD');
    this.state.registro.emp_cep = this.state.registro.emp_cep ? String(this.state.registro.emp_cep).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';

    this.props.onSalvarClick(this.state.registro);
  };


  handleChange = info => {
    // console.log('handleChange: ', info);

    const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
    if (!isJpgOrPng) {
      return;
    }
    const isLt2M = info.file.size / 1024 / 1024 < 0.1;
    if (!isLt2M) {
      return;
    }

    this.setState({
      registro: {
        ...this.state.registro,
        imgNome: '',
        imgSize: '',
        imgData: '',
        pathImagem: '',
        base64: '',
      },
    });

    getBase64(info.file.originFileObj, imageUrl =>
      this.setState({
        registro: {
          ...this.state.registro,
          imgNome: info.file.name,
          imgSize: info.file.size,
          imgData: info.file.lastModifiedDate,
          pathImagem: '',
          base64: imageUrl,
        },
        loading: false,
      }),
    );
  };

  normalizeCpfCnpj = () => {
    const { registro } = this.state;
    const cpfcnpj = registro.emp_cpf_cnpj
      ? registro.emp_cpf_cnpj
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
      : '';
    if (cpfcnpj) {
      if ((String(cpfcnpj).length) === 11) {
        registro['emp_cpf_cnpj'] = maskCPF(cpfcnpj);
        this.setState({ ['emp_cpf_cnpj']: maskCPF(cpfcnpj) });
      } else {
        registro['emp_cpf_cnpj'] = maskCNPJ(cpfcnpj);
        this.setState({ ['emp_cpf_cnpj']: maskCNPJ(cpfcnpj) });
      }
    }
  };





  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoCEP } = this.state;
    const { emp_codigo, emp_nome, emp_razao_social, emp_email, emp_cpf_cnpj, emp_cep, emp_endereco, emp_complemento,
      emp_bairro, emp_numero, emp_municipio, emp_fone1, emp_fone2, emp_fone3,
      emp_pasta_catalogo, emp_data_contrato, emp_vlr_mensal, emp_obs, base64, pathImagem
    } = this.state.registro;

    // console.log('EmpresaForm.this.state: ', this.state);

    const uploadButton = (
      <div>
        {this.state.loading ? <Icon type="loading" style={{ color: 'rgba(0,0,0,0.4)' }} /> : <Icon type="plus" style={{ color: 'rgba(0,0,0,0.4)' }} />}
        <div className="ant-upload-text">Logo</div>
      </div>
    );

    return (
      <Modal
        title={emp_codigo ? "Edição de Empresa" : "Cadastro de Empresa"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={6} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="emp_codigo"
                value={emp_codigo}
                readOnly
              />
            </Col>

            <Col xs={24} sm={6} className="camposEspacoDireita">
              <span>CPF/CNPJ</span>
              <InputForm
                id="emp_cpf_cnpj"
                ref="emp_cpf_cnpj"
                maxLength={60}
                onChange={this.onChange}
                value={emp_cpf_cnpj}
                validator={value => Boolean(value)}
                onBlur={this.normalizeCpfCnpj}
              // masker={String(emp_cpf_cnpj).length <= 13 ? maskCPF : maskCNPJ}
              />
              {/* <InputForm
                id="emp_cpf_cnpj"
                ref="emp_cpf_cnpj"
                maxLength={20}
                onChange={this.onChange}
                value={emp_cpf_cnpj}
                validator={value => Boolean(value)}
                masker={String(emp_cpf_cnpj).length <= 13 ? maskCPF : maskCNPJ}
              /> */}
            </Col>

            <Col xs={24} sm={12} >
              <span>Email</span>
              <InputForm
                id="emp_email"
                ref="emp_email"
                maxLength={100}
                onChange={this.onChange}
                value={emp_email}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Nome</span>
              <InputForm
                id="emp_nome"
                ref="emp_nome"
                maxLength={60}
                onChange={this.onChange}
                value={emp_nome}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Razão Social</span>
              <InputForm
                id="emp_razao_social"
                ref="emp_razao_social"
                maxLength={60}
                onChange={this.onChange}
                value={emp_razao_social}
                validator={value => Boolean(value)}
              />
            </Col>


            <Col xs={24} sm={3} style={{ marginTop: -20 }}>
              <span>CEP</span>
              <InputForm
                id="emp_cep"
                ref="emp_cep"
                value={emp_cep}
                maxLength={10}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={1} style={{ marginTop: 4, marginRight: 30 }}>
              <Tooltip title="Buscar Endereço" placement="topLeft">
                <Button
                  type="dashed"
                  icon="search"
                  htmlType="button"
                  loading={carregandoCEP}
                  onClick={() => this.onBuscarCEPClick(emp_cep)}
                />
              </Tooltip>
            </Col>

            <Col xs={24} sm={10} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Endereço</span>
              <InputForm
                id="emp_endereco"
                ref="emp_endereco"
                maxLength={200}
                onChange={this.onChange}
                value={emp_endereco}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={9} style={{ marginTop: -20 }}>
              <span>Complemento</span>
              <InputForm
                id="emp_complemento"
                ref="emp_complemento"
                maxLength={100}
                onChange={this.onChange}
                value={emp_complemento}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Nº</span>
              <InputForm
                id="emp_numero"
                ref="emp_numero"
                maxLength={5}
                onChange={this.onChange}
                value={emp_numero}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Bairro</span>
              <InputForm
                id="emp_bairro"
                ref="emp_bairro"
                maxLength={60}
                onChange={this.onChange}
                value={emp_bairro}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <MunicipioFrame
                label="Município"
                id="emp_municipio"
                value={emp_municipio}
                width={"100%"}
                onChange={this.onChangeMunicipio}
                descricaoPrimeiroItem="Todos os Municípios"
              />
            </Col>

            <Col xs={24} sm={5} style={{ paddingRight: 10, marginTop: -20 }}>
              <span>Telefone</span>
              <InputForm
                id="emp_fone1"
                ref="emp_fone1"
                value={emp_fone1}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={5} style={{ paddingRight: 10, marginTop: -20 }}>
              <span>Telefone</span>
              <InputForm
                id="emp_fone2"
                ref="emp_fone2"
                value={emp_fone2}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={5} style={{ paddingRight: 10, marginTop: -20 }}>
              <span>Telefone</span>
              <InputForm
                id="emp_fone3"
                ref="emp_fone3"
                value={emp_fone3}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            {/* <Col xs={24} sm={3} style={{ paddingRight: 10, marginTop: -20 }}>
              <span>Valor</span>
              <InputForm
                type="number"
                id="emp_vlr_mensal"
                ref="emp_vlr_mensal"
                value={emp_vlr_mensal}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -17 }}>
              <span>Data Contrato</span>
              <DatePicker
                onChange={this.onDateChange}
                format="DD/MM/YYYY"
                showToday={true}
                value={moment(emp_data_contrato, "DD/MM/YYYY", true)}
                style={{ width: "100%" }}
              />
            </Col> */}

            <Col xs={19} style={{ marginTop: -20 }}>
              <span>Observações</span>
              <InputForm
                id="emp_obs"
                ref="emp_obs"
                value={emp_obs}
                type="textarea"
                rows={5}
                maxLength={9500}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Tooltip title="Carregar Logo" placement="topLeft">
              <Col xs={24} sm={5} style={{ marginTop: 0, paddingLeft: 30 }}>
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={this.handleChange}
                >
                  {base64 || pathImagem ? <img src={base64 ? base64 : pathImagem} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              </Col>
            </Tooltip>

          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>

                {/* {emp_codigo ? (
                  <Button
                    type="danger"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onGravarParametrosClick}
                    className="btn-salvar"
                  >
                    Cad Padrão
                  </Button>
                ) : null} */}

              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmpresaForm.js